import { render, staticRenderFns } from "./DoctorRegisterHospitalAddModal.vue?vue&type=template&id=4c58dff4&scoped=true&"
import script from "./DoctorRegisterHospitalAddModal.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterHospitalAddModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterHospitalAddModal.vue?vue&type=style&index=0&id=4c58dff4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c58dff4",
  null
  
)

export default component.exports